export default __webpack_public_path__ + "static/banner-sightseeing-and-saving-5-tips-for-a-thrifty-holiday-c49a08af5c33052328fb8d23f7268850.jpg";